import { ReactComponent as SabespSvg } from 'assets/logo.svg';
import classNames from 'classnames';
import './styles.scss';

const Logo = ({ small }) => {
  const logoClass = classNames({
    logo: true,
    'logo--small': small,
  });

  return <SabespSvg className={logoClass} />;
};

export default Logo;
